// Brand identity for ools.me
// Logo is bundled in /public so it loads instantly and works as a favicon.
export const OOL_LOGO_URL = "/ool-logo.png";
export const DOMAIN = "ools.me";
export const DOMAIN_PARTS = { name: "ools", tld: ".me" };
export const SITE_TITLE = "ools.me — itz_ool on Twitch · daily streams";
export const SITE_DESCRIPTION =
    "ools.me — itz_ool, a variety streamer on Twitch building toward a top-50 spot. Daily streams, real community, live chat. Pull up.";
